import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import MenuCart from './sub-components/MenuCart';
import { logoutUser } from '../../store/slices/auth-slice';
import { useState, useEffect } from 'react';
import Notification from '../notification/Notification';

const IconGroup = ({ iconWhiteClass }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);
  const [notification, setNotification] = useState({
    message: '',
    type: 'info',
  });

  const handleClick = (e) => {
    e.currentTarget.nextSibling.classList.toggle('active');
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      '#offcanvas-mobile-menu'
    );
    offcanvasMobileMenu.classList.add('active');
  };

  const { compareItems } = useSelector((state) => state.compare);
  const { wishlistItems } = useSelector((state) => state.wishlist);
  const { cartItems } = useSelector((state) => state.cart);
  const { isAuthenticated } = useSelector((state) => state.auth);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await dispatch(logoutUser()).unwrap();
      navigate('/login-register');
      setNotification({
        message: 'You have been successfully logged out',
        type: 'success',
      });
      setShowNotification(true);
    } catch (error) {
      setNotification({
        message: error.message || 'Failed to logout',
        type: 'error',
      });
      setShowNotification(true);
    }
  };

  return (
    <div className={clsx('header-right-wrap', iconWhiteClass)}>
      {/* Notification component */}
      {showNotification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setShowNotification(false)}
        />
      )}

      <div className='same-style header-search d-none d-lg-block'>
        <button className='search-active' onClick={(e) => handleClick(e)}>
          <i className='pe-7s-search' />
        </button>
        <div className='search-content'>
          <form action='#'>
            <input type='text' placeholder='Search' />
            <button className='button-search'>
              <i className='pe-7s-search' />
            </button>
          </form>
        </div>
      </div>
      <div className='same-style account-setting d-none d-lg-block'>
        <button
          className='account-setting-active'
          onClick={(e) => handleClick(e)}
        >
          <i className='pe-7s-user-female' />
        </button>
        <div className='account-dropdown'>
          <ul>
            {isAuthenticated ? (
              <>
                <li>
                  <Link to={process.env.PUBLIC_URL + '/my-account'}>
                    My Account
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + '/my-orders'}>
                    My Orders
                  </Link>
                </li>
                <li>
                  <Link to='#' onClick={handleLogout}>
                    Logout
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to={process.env.PUBLIC_URL + '/login-register'}>
                    Login
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + '/login-register'}>
                    Register
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>

      <div className='same-style header-wishlist'>
        <Link to={process.env.PUBLIC_URL + '/wishlist'}>
          <i className='pe-7s-like' />
          <span className='count-style'>
            {wishlistItems && wishlistItems.length ? wishlistItems.length : 0}
          </span>
        </Link>
      </div>
      <div className='same-style cart-wrap d-none d-lg-block'>
        <button className='icon-cart' onClick={(e) => handleClick(e)}>
          <i className='pe-7s-shopbag' />
          <span className='count-style'>
            {cartItems && cartItems.length ? cartItems.length : 0}
          </span>
        </button>
        {/* menu cart */}
        <MenuCart />
      </div>
      <div className='same-style cart-wrap d-block d-lg-none'>
        <Link className='icon-cart' to={process.env.PUBLIC_URL + '/cart'}>
          <i className='pe-7s-shopbag' />
          <span className='count-style'>
            {cartItems && cartItems.length ? cartItems.length : 0}
          </span>
        </Link>
      </div>
      <div className='same-style mobile-off-canvas d-block d-lg-none'>
        <button
          className='mobile-aside-button'
          onClick={() => triggerMobileMenu()}
        >
          <i className='pe-7s-menu' />
        </button>
      </div>
    </div>
  );
};

IconGroup.propTypes = {
  iconWhiteClass: PropTypes.string,
};

export default IconGroup;
